import React from 'react';
import { observer } from 'mobx-react';
import CustomerSuccessHistoryService from '../services/CustomerSuccessHistoryService';
import { toJS } from 'mobx';
import KpiDialogHistory from '../../commons/KpiDialogHistory';

const CustomerSuccessHistoryDialogContainer = () => (
  <KpiDialogHistory
    isOpen={CustomerSuccessHistoryService.isOpen}
    onCancel={CustomerSuccessHistoryService.closeDialog}
    data={toJS(CustomerSuccessHistoryService.history)}
    isLoading={CustomerSuccessHistoryService.fetch.fetching}
    indicator={CustomerSuccessHistoryService.indicator}
    valueFormatter={CustomerSuccessHistoryService.getFormattedValue}
    indicatorFormatter={CustomerSuccessHistoryService.getFormattedIndicator}
  />
);

export default observer(CustomerSuccessHistoryDialogContainer);
